import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, InputGroup } from "../../../UI";
import { broadCastNotification } from "../../../redux/actions";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Container from "./style";
import { useSelector } from "react-redux";

const Notification = () => {
  const { gymLocations } = useSelector((s) => s.dashStats);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ subject: "", location_id: 1 });
  const [message, setMessage] = useState("");

  const handleBroadCast = () => {
    if (window.confirm("Are you sure you want to send out this broadcast")) {
      setLoading(true);
      broadCastNotification({
        message,
        ...formData,
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  const handleInput = ({ target: { name, value } }) => {
    setFormData((s) => ({ ...s, [name]: value }));
  };

  return (
    <Container>
      <header className="component-header" style={{ marginBottom: "1.5em" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <h1 style={{ fontSize: "1.1rem", fontWeight: 600, color: "#006633" }}>Send Push Notification Broadcast</h1>
            <p style={{ color: "#666", fontSize: "0.9rem", marginTop: "5px" }}>
              Send immediate, one-time broadcast messages to users' mobile devices. These are not persistent pop-ups.
            </p>
          </div>
          <Link to="/admin/dashboard/announcement" style={{ fontSize: "0.85rem", color: "#1890ff", fontWeight: "500", textDecoration: "underline" }}>
            Manage Home Pop-ups instead?
          </Link>
        </div>
      </header>
      <InputGroup
        label="Message Subject"
        name="subject"
        value={formData.subject}
        placeholder={"Welcome to Ecofitness..."}
        onChange={handleInput}
      />
      <InputGroup>
        <label>Location</label>
        <select
          name="location_id"
          required={true}
          onChange={handleInput}
          value={formData.location_id}
        >
          {Object.keys(gymLocations).map((locationId) => (
            <option value={locationId}>{gymLocations[locationId]}</option>
          ))}
        </select>
      </InputGroup>
      <div>
        <ReactQuill
          theme="snow"
          style={{ height: "50vh" }}
          value={message}
          onChange={setMessage}
        />
      </div>
      <Button
        className={"notificationBtn"}
        loading={loading}
        onClick={handleBroadCast}
        disabled={!formData.subject || !formData.location_id || !message}
      >
        Send Notification
      </Button>
    </Container>
  );
};

export default Notification;
